module.exports = __webpack_public_path__ + "static/Logo_8-7995d5b9a11b71d5006a425958d0aa01.png";